import {FC, memo, useEffect} from 'react'
import {useTranslation} from 'react-i18next'
import DatePickerV2 from '../../../components/DatePickerV2/DatePickerV2'
import {Selection} from '../../../components/Selection'
import {TextInputV2} from '../../../components/TextInputV2'
import {PAYMENT_TYPE, PRODUCT_TYPE, SECTOR_OPTIONS, SO_STATUS} from '../../../constants'
import {useSalesOrganization} from '../../../hooks/useSalesOrganization'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {filterSelector, setFilterSO} from '../../../redux/slices/filterSlices'
import {TRowFilter} from '../../../components/Table/Table'

interface RowFilterProps {
  // role: 'null' | 'anper' | 'admin' | 'salesAnper' | 'salesAdmin' | 'otorisator' | 'finance'
  role: string
}

export const RowFilter: FC<RowFilterProps> = (props) => {
  const {t} = useTranslation()
  const {salesOrgOptions} = useSalesOrganization()
  const {filterSO: filter} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()

  const {role} = props
  const isNullRole = role === 'null'

  const handleFilterChange = (value: Partial<typeof filter>) => {
    dispatch(setFilterSO({...filter, ...value}))
  }

  useEffect(() => {
    let _filter = filter
    try{
      let persisted = JSON.parse(localStorage.getItem('redux-so-filter') as string)
      _filter = {
        ...filter,
        ...persisted
      }
      dispatch(setFilterSO(_filter))
    }catch(e){
      console.log(e)
    }
  }, [])

  return (
    <TRowFilter>
      <td>
        <div>&nbsp;</div>
      </td>
      <td>
        <TextInputV2
          placeholder={t('kontrak-soNomor')}
          value={filter?.so_number ?? ''}
          onChange={({target}) => handleFilterChange({so_number: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('order-no')}
          value={filter?.po_number ?? ''}
          onChange={({target}) => handleFilterChange({po_number: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('kontrak-kodeBooking')}
          value={filter?.booking_code ?? ''}
          onChange={({target}) => handleFilterChange({booking_code: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('SO Number')}
          value={filter?.sap_number ?? ''}
          onChange={({target}) => handleFilterChange({sap_number: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('order-pelanggan')}
          value={filter?.customer_name ?? ''}
          onChange={({target}) => handleFilterChange({customer_name: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('sip-number')}
          value={filter?.sip_number ?? ''}
          onChange={({target}) => handleFilterChange({sip_number: target.value})}
        />
      </td>
      <td className='td-order-4 text-center pm-0'>
        <Selection
          data={salesOrgOptions}
          placeholder={t('Sales Org')}
          value={filter?.sales_org_code ?? ''}
          onChange={(value: any) => handleFilterChange({sales_org_code: value})}
        />
      </td>
      <td className='td-order-3 text-center pm-0'>
        <Selection
          data={SECTOR_OPTIONS}
          placeholder={t('Sektor')}
          value={filter?.sector_id ?? ''}
          onChange={(value: any) => handleFilterChange({sector_id: value})}
        />
      </td>
      <td>
        <DatePickerV2
          placeholder={t('order-tanggal')}
          startDate={filter?.from_date ?? ''}
          endDate={filter?.to_date ?? ''}
          onChange={(values) => {
            const from_date = values?.startDate === 'Invalid date' ? '' : values?.startDate
            const to_date = values?.endDate === 'Invalid date' ? '' : values?.endDate
            handleFilterChange({from_date, to_date})
          }}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('sub-order-jenis')}
          value={filter?.product_type ?? ''}
          onChange={({target}) => handleFilterChange({product_type: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('kontrak-kuantum')}
          value={filter?.total_quantum_so ?? ''}
          onChange={({target}) => handleFilterChange({total_quantum_so: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Total Price')}
          value={filter?.price_after_ppn ?? ''}
          onChange={({target}) => handleFilterChange({price_after_ppn: target.value})}
        />
      </td>
      <td>
        <Selection
          placeholder={t('Metode Pembayaran')}
          data={PAYMENT_TYPE}
          value={filter?.payment_type ?? ''}
          onChange={(payment_type) => handleFilterChange({payment_type})}
        />
      </td>
      <td>
        <Selection
          data={
            isNullRole
              ? SO_STATUS.map((item) =>
                  item.label === 'SAP Error' ? {...item, label: 'Pending'} : item
                )
              : SO_STATUS
          }
          placeholder={'Status'}
          value={filter?.status ?? ''}
          onChange={(value: any) => handleFilterChange({status: value})}
        />
      </td>
      <td>
        <div style={{padding: '.9rem'}}>&nbsp;</div>
      </td>
    </TRowFilter>
  )
}

export default memo(RowFilter)
